import {
  ButtonIcon,
  ButtonSize,
  ButtonVariant,
  DropDownMenu,
  DropDownMenuItem,
  DropdownProps,
  IconVariants,
  Shape,
} from "@next-platform/client-common-spicy-ui";

type InputActionMenuProps = {
  menuItems: DropDownMenuItem[];
  disabled: boolean;
  // Defaults to `disabled` so a transient disable (e.g. a response is generating) still
  // shows the spinner as before. Callers with a permanent disable reason (e.g. the group
  // chat is unavailable) should pass `loading={false}` explicitly, since that condition
  // never resolves and would otherwise spin forever.
  loading?: boolean;
  placement?: DropdownProps["placement"];
};

const InputActionMenu = ({ menuItems, disabled, loading = disabled, placement = "top-start" }: InputActionMenuProps) => {
  return (
    <DropDownMenu listItems={menuItems} placement={placement}>
      <ButtonIcon
        loading={loading}
        disabled={disabled}
        variant={ButtonVariant.SECONDARY}
        icon={IconVariants.PLUS}
        size={ButtonSize.MEDIUM}
        shape={Shape.PILL}
      />
    </DropDownMenu>
  );
};

export default InputActionMenu;
